/**
 * Generates required data object from locationCart
 * @param {Object} locationCart - Cart object containing order details
 * @param {Object} extra - Additional params not present in locationCart (e.g. { shop_type, organizer_id, orientation })
 * @returns {Object} Formatted data payload
 */
function generateLocationCartData(locationCart, extra) {
  var data = {
    location_id: locationCart.location_id,
    location_type: locationCart.location_type,
    table_number: locationCart.table_number,
    products: locationCart.products,
    tips_percent: locationCart.tips_percent,
    payment_method: locationCart.payment_method ?? '',
    comment: locationCart.comment,
    promo_code: locationCart.promo_code,
    amount_without_discount: locationCart.amount_without_discount ?? 0,
    alter_amount_without_discount:
      locationCart.alter_amount_without_discount ?? 0,
    customer_id: locationCart.customer_id || '',
    customer_contact_person_id: locationCart.customer_contact_person_id || '',
    pos_type: locationCart.pos_type,
    table_id: locationCart.table_number || '',
    order_discount_percent: locationCart.order_discount_percent,
    share_amount: locationCart.share_amount ?? 0,
    table_customer_id: locationCart.table_customer_id ?? '',
    isCartOpened: localStorage.getItem('isCartOpened'),
    add_to_cart_from_table: locationCart.add_to_cart_from_table ?? 0,
    always_reopen_split_modal: locationCart.alwaysReopenModal ?? 0,
    is_takeaway_checked: locationCart.is_takeaway_checked ?? 0,
  };

  if (locationCart.checkout_type) {
    data.checkout_type = locationCart.checkout_type;
  }

  return $.extend({}, data, extra ?? {});
}

/**
 * Displays the order success checkmark animation
 */
function showOrderSuccessCheckmark() {
  if ($('#order-success-check').hasClass('d-none-custom')) {
    $('#order-success-check').removeClass('d-none-custom');
    const $checkSVG = $('#order-success-check-svg');
    $checkSVG.addClass('animate');

    setTimeout(function () {
      $('#order-success-check').addClass('d-none-custom');
      $checkSVG.removeClass('animate');
      void $checkSVG[0].offsetWidth;
    }, 750);
  }
}
